export default __webpack_public_path__ + "static/media/2161.f015b882.png";